export default function Go_Struct() {
  return (
    <div>
      <h1>Go_Struct </h1>
      <p>Go Struct</p>
    </div>
  );
}
